import { createAction } from 'Lib/reduxUtils';

import {
  CLEAR_DEEPLINK_NAVIGATION_INFO,
  CLEAR_DEEPLINK_OTP,
  CLEAR_DEEPLINK_PROMO,
  COMPLETE_3DS,
  DELETE_ACCOUNT,
  DELETE_ACCOUNT_SUCCESS,
  GOLD_DEEPLINK_ACTIVE,
  GOLD_DEEPLINK_SUCCESS,
  POST_GUEST_LOGIN,
  POST_LOGIN,
  REQUEST_AGE_VERIFICATION_URL,
  REQUEST_AGE_VERIFICATION_URL_ERROR,
  REQUEST_AGE_VERIFICATION_URL_SUCCESS,
  SET_APPEALABLE_BAN_CHALLENGE_TOKEN,
  SET_ARKOSE_DATA_BLOB,
  SET_DEEPLINK_INCENTIVES_INFO,
  SET_DEEPLINK_INTRO_PRICE_INFO,
  SET_DEEPLINK_NAVIGATION_INFO,
  SET_DEEPLINK_PROMO,
  SET_DEEPLINK_VERIFICATION_INFO,
  SET_IS_UNDERAGE_ONBOARDING,
  SET_SELFIE_VERIFICATION_ATTEMPTED,
  SET_UNDERAGE_TOKEN,
  STORE_POST_LOGIN_REDIRECT_PATH,
  VERIFY_AGE_VERIFICATION_STATUS,
  VERIFY_LOGIN_REDIRECT,
} from './constants';

export const postLogin = createAction(POST_LOGIN);
export const postGuestLogin = createAction(POST_GUEST_LOGIN);
export const deleteAccount = createAction(DELETE_ACCOUNT, (deletionModalVersion: number) => ({
  deletionModalVersion,
}));
export const deleteAccountSuccess = createAction(DELETE_ACCOUNT_SUCCESS);
export const setAppealableBanChallengeToken = createAction(
  SET_APPEALABLE_BAN_CHALLENGE_TOKEN,
  (token: string) => token
);
export const setArkoseDataBlob = createAction(
  SET_ARKOSE_DATA_BLOB,
  (arkoseDataBlob: string) => arkoseDataBlob
);
export const set3DSComplete = createAction(COMPLETE_3DS);
export const setDeeplinkVerificationInfo = createAction(
  SET_DEEPLINK_VERIFICATION_INFO,
  (payload: any) => payload
);
export const setDeeplinkNavigationInfo = createAction(
  SET_DEEPLINK_NAVIGATION_INFO,
  (payload: any) => payload
);
export const clearDeeplinkNavigationInfo = createAction(CLEAR_DEEPLINK_NAVIGATION_INFO);
export const setDeeplinkIncentivesInfo = createAction(
  SET_DEEPLINK_INCENTIVES_INFO,
  (payload: any) => payload
);
export const setDeeplinkIntroPriceInfo = createAction(
  SET_DEEPLINK_INTRO_PRICE_INFO,
  (payload: any) => payload
);
export const setDeeplinkToPromo = createAction(SET_DEEPLINK_PROMO);
export const clearDeeplinkToPromo = createAction(CLEAR_DEEPLINK_PROMO);
export const setGoldDeeplinkActive = createAction(GOLD_DEEPLINK_ACTIVE);
export const setGoldDeeplinkSuccess = createAction(GOLD_DEEPLINK_SUCCESS);
export const clearDeeplinkOtp = createAction(CLEAR_DEEPLINK_OTP);
export const requestAgeVerificationUrlError = createAction(
  REQUEST_AGE_VERIFICATION_URL_ERROR,
  (errorCode?: any) => ({ errorCode })
);
export const requestAgeVerificationUrlSuccess = createAction(
  REQUEST_AGE_VERIFICATION_URL_SUCCESS,
  (payload: any) => payload
);
export const requestAgeVerificationUrl = createAction(REQUEST_AGE_VERIFICATION_URL);
export const verifyLoginRedirect = createAction(VERIFY_LOGIN_REDIRECT);
export const verifyAgeVerificationStatus = createAction(VERIFY_AGE_VERIFICATION_STATUS);

export const setUnderageToken = createAction(
  SET_UNDERAGE_TOKEN,
  (underageToken: string) => underageToken
);

export const setIsUnderageOnboarding = createAction(
  SET_IS_UNDERAGE_ONBOARDING,
  (isUnderageOnboarding: boolean) => isUnderageOnboarding
);

export const setSelfieVerificationAttempted = createAction(
  SET_SELFIE_VERIFICATION_ATTEMPTED,
  (attempted: boolean) => attempted
);

export const storePostLoginRedirectPath = createAction(
  STORE_POST_LOGIN_REDIRECT_PATH,
  ({ path, pushState }: { path: string; pushState: boolean }) => ({ path, pushState })
);
